<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px; margin-left: 10px; width: 100%;">
      <div style="float: left">
        <el-button type="danger" @click="submitFlow" style="color: #FFFFFF">提交审批</el-button>
        <el-button type="primary" @click="showAddBox" style="color: #FFFFFF">新增</el-button>
        <el-button @click="search()">查询</el-button>
      </div>
      <div style="float: right; margin-right: 20px">

      </div>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="奖罚月份">
          <el-date-picker
            v-model="params.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="所在项目">
          <el-input size="mini" placeholder="" v-model="params.department_name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="params.status" clearable placeholder="请选择">
            <el-option label="待提交" value="0"></el-option>
            <el-option label="待审批" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
            <el-option label="已通过" value="10"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
    </div>
    <el-table ref="Table" v-if="list" :data="list" height="680px" :cell-style="cellStayle"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="batch_number" width="180" label="批次号" align="center"></el-table-column>
      <el-table-column prop="project" width="250" label="项目" align="center"></el-table-column>
      <el-table-column prop="name"  label="员工" align="center"></el-table-column>
      <el-table-column prop="job" label="岗位" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0">待提交</el-tag>
          <el-tag v-if="scope.row.status == 1" type="warning">待审批</el-tag>
          <el-tag v-if="scope.row.status == 2" type="danger">拒绝</el-tag>
          <el-tag v-if="scope.row.status == 10" type="success">通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="month" label="奖罚月份" align="center"></el-table-column>
      <el-table-column prop="temperature_money" width="80" label="高温补贴" align="center"></el-table-column>
      <el-table-column prop="festival_money" width="80" label="过节费" align="center"></el-table-column>
      <el-table-column prop="internship_money" width="80" label="顶岗费用" align="center"></el-table-column>
      <el-table-column prop="other_money" width="80" label="其他奖励" align="center"></el-table-column>
      <el-table-column prop="other_subtract_money" width="80" label="其他扣款" align="center"></el-table-column>
      <el-table-column prop="remark" width="80" label="备注" align="center"></el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 0 || scope.row.status == 2" size="mini" type="primary" style="color: #FFFFFF" @click="showEditBox(scope.row)">修改</el-button>
          <el-button v-if="scope.row.status == 0" size="mini" type="danger" style="color: #FFFFFF" @click="delReward(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="params.total"
                   :current-page="params.page"
                   :page-size="params.pageSize"
                   :page-sizes="[15, 30, 50, 100]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="添加" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1300px">
      <div style="max-height: 100px;overflow-y: auto;">
        <div class="search-wrap" style="margin-bottom: 10px">
          <el-button size="mini" type="primary" @click="userSearch()" style="margin-right: 5px;color: #FFFFFF" icon="el-icon-search">
            查询
          </el-button>
        </div>
        <el-descriptions :column="3" border size="mini">
          <el-descriptions-item label="所在项目">
            <el-input placeholder="" v-model="userParams.department_name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="姓名">
            <el-input placeholder="" v-model="userParams.name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="手机号码">
            <el-input placeholder="" v-model="userParams.phone_number" clearable></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="table-wrap">
        <el-table ref="Table" v-if="userData" :data="userData.list" height="500px"  @selection-change="userHandleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="project" width="180" label="项目" align="center"></el-table-column>
          <el-table-column prop="name" width="60" label="姓名" align="center"></el-table-column>
          <el-table-column prop="job" width="80" label="岗位" align="center"></el-table-column>
          <el-table-column prop="phone_number" width="100" label="手机号码" align="center"></el-table-column>
          <el-table-column prop="month" label="奖罚月份" width="150" align="center">
            <template slot-scope="scope">
              <el-date-picker style="width: 120px" readonly="true" v-model="scope.row.month" type="month" value-format="yyyy-MM" placeholder="选择月"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="temperature_money" label="高温补贴" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder="" v-model="scope.row.temperature_money" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="festival_money" label="过节费" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder="" v-model="scope.row.festival_money" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="internship_money" label="顶岗费用" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder="" v-model="scope.row.internship_money" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="other_money" label="其他奖励" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder="" v-model="scope.row.other_money" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="other_subtract_money" label="扣款金额" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder=""  v-model="scope.row.other_subtract_money" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="remark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input size="mini" placeholder=""  v-model="scope.row.remark" clearable style="width: 100%"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="userParams.total*1" :page-size="userParams.pageSize*1" :current-page="userParams.page*1" @current-change="userPageChange"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="userConfirm()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" z-index="990" :visible.sync="editDialogVisible" :close-on-click-modal="false" width="700px">
      <div class="table-wrap">
        <el-descriptions :column="2" border size="mini">
          <el-descriptions-item label="姓名">
            {{ editUserData.name }}
          </el-descriptions-item>
          <el-descriptions-item label="奖罚月份">
            <el-date-picker
              v-model="editUserData.month"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月份">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="高温补贴">
            <el-input v-model="editUserData.temperature_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="过节费">
            <el-input v-model="editUserData.festival_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="顶岗费用">
            <el-input v-model="editUserData.internship_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="其他奖励">
            <el-input v-model="editUserData.other_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="其他扣款">
            <el-input v-model="editUserData.other_subtract_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="其他扣款">
            <el-input v-model="editUserData.other_subtract_money" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input v-model="editUserData.remark" placeholder=""></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editDialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="userEditConfirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Http from "../common/Http";

export default {
  name: 'RewardList',
  data() {
    return {
      dayList: [],
      list: [],
      selectRewardList: [],
      dialogVisible: false,
      editDialogVisible: false,
      month:"",
      params: {
        month: "",
        department_name: "",
        name: "",
        total: 0,
        page: 1,
        pageSize: 15,
        status: ""
      },
      userData: {
        list: [],
        selectUserList: []
      },
      userParams: {
        total: 0,
        page: 1,
        pageSize: 20,
        department_name: "",
        name: "",
        phone_number: "",
      },
      editUserData: {
        id : 0,
        name : "",
        month : "",
        temperature_money : 0,
        festival_money : 0,
        internship_money : 0,
        other_money : 0,
        other_subtract_money : 0,
        remark : "",
      }

    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    let date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month
    }
    // this.params.month = date.getFullYear() + '-' + month;
    this.month = date.getFullYear() + '-' + month;
    this.dayList = this.getDayList(this.params.month)
    this.getRewardList()
  },
  methods: {

    search() {
      this.params.page = 1;
      this.getRewardList()
    },
    exportExcel() {

    },
    getRewardList() {
      let params = this.params
      Http.get(Http.getPreBaseURL() + '/oa/Reward/getList', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
          this.params.page = res.data.current_page;
          this.params.pageSize = res.data.per_page;
          this.params.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },

    handleCurrentChange(val) {
      this.params.page = val
      this.getRewardList()
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getRewardList()
    },


    showAddBox() {
      this.dialogVisible = true
      this.userData.selectUserList = [];
      this.getUserList();
    },
    showEditBox(data) {
      this.editDialogVisible = true
      this.editUserData.id = data.id
      this.editUserData.name = data.name
      this.editUserData.month = data.month
      this.editUserData.temperature_money = data.temperature_money
      this.editUserData.festival_money = data.festival_money
      this.editUserData.internship_money = data.internship_money
      this.editUserData.other_money = data.other_money
      this.editUserData.other_subtract_money = data.other_subtract_money
      this.editUserData.remark = data.remark
    },

    // 获取员工信息
    getUserList() {
      let params = this.userParams
      Http.get(Http.getPreBaseURL() + '/oa/user/getUserInfoList', params, res => {
        if (res.code === 0) {
          let list = [];
          for (let i = 0; i < res.data.data.length; i++) {
            let item = res.data.data[i]
            item['temperature_money'] = 0;
            item['festival_money'] = 0;
            item['internship_money'] = 0;
            item['other_money'] = 0;
            item['other_subtract_money'] = 0;
            item['remark'] = "";
            item['month'] = this.getLastMonth(this.month);
            list[i] = item;
          }
          this.userData.list = list
          this.userParams.total = res.data.total
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    userPageChange(i) {
      this.userParams.page = i
      this.getUserList()
    },
    userSearch() {
      this.userParams.page = 1
      this.getUserList()
    },
    userHandleSelectionChange(val) {
      this.userData.selectUserList = val;
    },
    handleSelectionChange(val) {
      this.selectRewardList = val;
    },
    userConfirm() {
      let params = {
        'select_user_list' : this.userData.selectUserList
      }
      Http.post(Http.getPreBaseURL() + '/oa/Reward/addBatch', params, res => {
        if (res.code === 0) {
          this.getRewardList()
          this.dialogVisible = false
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    userEditConfirm() {
      let params = this.editUserData
      Http.post(Http.getPreBaseURL() + '/oa/Reward/edit', params, res => {
        if (res.code === 0) {
          this.editDialogVisible = false
          this.getRewardList()
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    delReward(id) {
      this.$confirm('此操作将永久删除该奖惩记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get(Http.getPreBaseURL() + '/oa/Reward/del', {id:id}, res => {
          if (res.code === 0) {
            this.getRewardList()
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            })
          }
        })
      });
    },
    // 提交审核
    submitFlow() {
      let that = this
      if (this.selectRewardList.length === 0) {
        this.$message.error({
          message: "请选择需要提交的奖惩记录！",
          type: "error",
        })
      }
      let params = {
        'select_reward' : this.selectRewardList
      }
      Http.post(Http.getPreBaseURL() + '/oa/Reward/submitFlow', params, res => {
        if (res.code === 0) {
          this.editDialogVisible = false
          this.getRewardList()
          // 跳转到流程审批
          that.$router.push({
            path: '/flow/FlowView',
            query: {
              'sheet_id': 67,
              'master_id': 64,
              'timeValue': Date.now(),
              'batch_number': res.data,
            }
          });
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    cellStayle({row, column, rowIndex, columnIndex}) {
      if (column.label === '高温补贴') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '顶岗费用') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '过节费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他奖励') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他扣款') {
        if (row.other_subtract_money > 0) {
          return 'background-color : #FFAAAA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #FFAAAA'
        }
      }
    },
    getLastMonth(startTime) {
      let year, lastMonth;
      const date = new Date(startTime.substring(0, 4), startTime.substring(5, 7));
      const nowYear = date.getFullYear();   //当前年：四位数字
      const nowMonth = date.getMonth() - 1;     //当前月：0-11
      if (nowMonth == 0) {   //如果是0，则说明是1月份，上一个月就是去年的12月
        year = nowYear - 1;
        lastMonth = 12;
      }else { //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
        year = nowYear;
        lastMonth = nowMonth;
      }
      lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth;   //月份格式化：月份小于10则追加个0
      let lastYearMonth = year + '-' + lastMonth;
      return lastYearMonth;
    },
    // 获取本月日期列表
    getDayList(value) {
      const weekdayTitle = {0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'}
      const dayNumber = moment(value).daysInMonth()
      let dayList = []
      for (let i = 1; i <= dayNumber; i++) {
        let day = moment(value).format('YYYY-MM') + '-' + (i < 10 ? '0' + i : i)
        let weekday = moment(day).weekday()
        dayList.push({day: day, title: i + '<br>' + weekdayTitle[weekday]})
      }
      return dayList
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Attendance/rewardList.vue